// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__gtWlQ","inner":"Badge_inner__ZlteB","text":"Badge_text__DkZqQ","themed":"Badge_themed__BPtEp"};